<mat-card id='view-programmes'>
  <mat-card-header>
    <span class="header-search">
      <mat-form-field id="search_service_user_form" appearance="fill" class="search_by_lr">
        <input id="search_service_user_input" autocomplete="off" (keydown.enter)="onFilter(search_service_user_input.value)" matInput
          #search_service_user_input aria-label="Search a user">
           <div matSuffix class="search-actions">
    <button
      mat-icon-button
      [disableRipple]="true"
      (click)="onFilter(search_service_user_input.value)">
      <mat-icon>search</mat-icon>
    </button>

    @if (search_service_user_input.value !== '') {
      <button
        mat-icon-button
        [disableRipple]="true"
        (click)="onFilter(''); search_service_user_input.value=''">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>       
        </mat-form-field>
      </span>

      <span class="header-search ml-2">
        <mat-form-field appearance="fill">
          <mat-select (selectionChange)="findWorker($event)" [(ngModel)]="select">
            <mat-option value="All Service Users">All Participants</mat-option>
            <mat-option value="My Service Users">My Participants</mat-option>
          </mat-select>
        </mat-form-field>
      </span>
      <span class="spacer1"></span>
      @if (showcaseLoad && filteredListSize > 0) {
        <span>
          <button id="create_service_user_button" mat-stroked-button class="right" color="primary"
            (click)="openCaseLoadPopup()">Print my caseload
            <div id="form_holder" style="display: none;"></div>
          </button>
        </span>
      }
      <span class="spacer"></span>
      <span>
        <button *auth="[9,1]" id="add_learner_button" mat-stroked-button class="right" color="primary"
        (click)="onClickAddParticipant()">Add participant</button>
      </span>
    </mat-card-header>

    <mat-card-content class="learners">

      <span class="spacer"></span>


      <mat-table id="learners_table" #table class="isMobile" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="fullName">
          <mat-header-cell *matHeaderCellDef id="fullName" mat-sort-header>
            Name
          </mat-header-cell>
          <mat-cell *matCellDef="let element"><span class="mobile-label">Name:
          </span>
          {{ element.fullName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="DateofBirth">
        <mat-header-cell *matHeaderCellDef id="DateofBirth">
          Date of birth
        </mat-header-cell>
        <mat-cell *matCellDef="let element"><span class="mobile-label">Date of Birth:
        </span>
        {{ element.dateOfBirth | customMonthFormat}}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Username">
      <mat-header-cell *matHeaderCellDef id="Username">
        Username
      </mat-header-cell>
      <mat-cell *matCellDef="let element"><span class="mobile-label">Username:
      </span>
      {{ element.email }}
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="Number">
    <mat-header-cell *matHeaderCellDef id="Number">
      Telephone Number
    </mat-header-cell>
    <mat-cell *matCellDef="let element"><span class="mobile-label">Telephone Number:
    </span>
    {{ element.contactNo }}
  </mat-cell>
</ng-container>
<ng-container matColumnDef="Worker">
  <mat-header-cell *matHeaderCellDef id="Worker">
    Worker
  </mat-header-cell>
  <mat-cell *matCellDef="let element"><span class="mobile-label">Worker:
  </span>
  {{ element.workerName ?? 'N/A' }}
</mat-cell>
</ng-container>

<ng-container matColumnDef="actions">
  <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
  <mat-cell *matCellDef="let element">

    <button *auth="[9,2]" id="view_user_button_{{element.id}}" mat-icon-button color="primary"
      matTooltip="View" [matTooltipShowDelay]="800" class="mat-style"
      [routerLink]="['./participant-professional-view']" [queryParams]="{ id: element.id ,name:element.fullName,operation:'view' }">
      <mat-icon>visibility</mat-icon>
    </button>
    <button  *auth="[9,3]" id="edit_user_button_{{element.id}}" mat-icon-button color="primary" class="mat-style"
      [routerLink]="['./edit-learner']" [queryParams]="{ id: element.id ,name:element.fullName,operation:'edit' }" matTooltip="Edit"
      [matTooltipShowDelay]="800">
      <mat-icon>create</mat-icon>
    </button>
    <button *auth="[9,4]" id="delete_user_button" mat-icon-button attr.aria-label="Delete" matTooltip="Delete" (click)="onDeleteClicked(element.id)"
      [matTooltipShowDelay]="800">
      <mat-icon color="accent">delete</mat-icon>
    </button>
  </mat-cell>
</ng-container>
<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>
<mat-paginator id="user_pagination" [pageSize]="pageSize" [showFirstLastButtons]='true' [hidePageSize]="true">
</mat-paginator>
</mat-card-content>
</mat-card>

